import React from 'react';

import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ActionEducation from 'material-ui/svg-icons/social/school';

const h2Icon = {
  marginLeft: 24,
  marginRight: 24,
};

let page = (props) => (
  <div>
    <h2><ActionEducation style={h2Icon} />Education</h2>
    <List>
      <ListItem
        primaryText={<span><strong>2019</strong> Ph.D. in Software Engineering</span>}
        secondaryText="at BTH - Bleking Tekniska Högskola"
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText={<span><strong>2013</strong> M.Sc. in Applied Computing</span>}
        secondaryText="at UNIVALI - Universidade do Vale do Itajaí"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span><strong>2006</strong> B.Sc. in Computer Science</span>}
        secondaryText="at UNIVALI - Universidade do Vale do Itajaí"
        disabled="true"
        insetChildren="true"
      />
    </List>
  </div>
);

export default page;



// WEBPACK FOOTER //
// ./src/components/Home/Education.js